import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { EventRow } from "@/pages/EventsPage";

export const MyEvents = () => {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/events/mine").then((r) => setEvents(r.data)); }, []);
  const unregister = async (e) => {
    try {
      await api.post(`/events/${e.id}/register`);
      setEvents((l) => l.filter((x) => x.id !== e.id));
      toast.success("Iscrizione annullata");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };
  if (!events) return <p className="py-10 text-stone-500">Caricamento...</p>;
  if (!events.length) return <p className="py-10 text-stone-600" data-testid="my-events-empty">Nessuna iscrizione. <Link to="/eventi" className="font-semibold text-amber-600">Guarda il calendario →</Link></p>;
  return <div className="space-y-3" data-testid="my-events-list">{events.map((e) => <EventRow key={e.id} e={e} onRegister={unregister} />)}</div>;
};
